import { trackMetaCustomEvent } from '../lib/meta';

/**
 * Landing page funnel analytics. Uses the existing Meta custom-event
 * convention (console in development). Never include raw prompt text,
 * uploaded filenames, personal data, or generated content in properties.
 */
export function trackLandingEvent(eventName, properties = {}) {
  try {
    trackMetaCustomEvent(eventName, properties);
  } catch (err) {
    console.warn('Landing analytics failed:', err);
  }
}

export const LANDING_EVENTS = {
  composerFocused: 'landing_composer_focused',
  suggestionSelected: 'landing_suggestion_selected',
  promptSubmitted: 'landing_prompt_submitted',
  authOpenedFromPrompt: 'landing_auth_opened_from_prompt',
  generationStarted: 'landing_generation_started',
  composerSubmitted: 'composer_submitted',
  exampleOpened: 'landing_example_opened',
  agentViewed: 'landing_agent_viewed',
  factoryViewed: 'landing_factory_viewed',
  resultsViewed: 'landing_results_viewed',
  faqOpened: 'landing_faq_opened',
  themeChanged: 'landing_theme_changed',
};
